<app-accordion [elementId]="subSubSubSubGroup.id"
              [prefixId]=" prefixId"
               [isDeletable]="subSubSubSubGroup.deletable"
               [elementLabel]="subSubSubSubGroup._label"
               [isRepeatable]="subSubSubSubGroup._repeatable"
               [infoBulle]="subSubSubSubGroup.infoBulle"
               [groupType]="getGroupType(subSubSubSubGroup.id)"
               (addSomething)="addSubSubSubSubGroup()"
               (deleteSomething)="removeSubSubSubSubGroup()">
 <p class="messageInfo">
  {{parcoursUtilisateur(subSubSubSubGroup)}}
                                                           </p>
    <div *ngFor="let field of subSubSubSubGroup.fields; let i = index">
      <app-form-input [prefixId]="prefixId" [parentForm]="formGroup"
                      [field]="field" [subSectionId]="subSectionId"
                      [repeatablePath]="repeatablePath" [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
                      [getRepeatablePathWithIndexForInput]="getRepeatablePathWithIndexForInput"
                      [noticeValue]="noticeValue" [groupOrSectionId]="subSubSubSubGroup.id"
                      (newField)="newField($event)"
                      (deleteField)="deleteField($event)" [index]="index"></app-form-input>
    </div>
</app-accordion>
